// @/api/model/damandManage.js

import config from "@/config";
import http from "@/utils/request";

export default {
	page: {
		url: `${config.MAIN_URL}/market/demand/demandManageList`,
		name: "需求管理分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getClientCompany: {
		url: `${config.MAIN_URL}/market/contract/getClientCompany`,
		name: "客户单位下拉",
		get: async function () {
			return await http.get(this.url);
		},
	},
	getContractName: {
		url: `${config.MAIN_URL}/market/contract/getContractName`,
		name: "合同名称下拉",
		get: async function () {
			return await http.get(this.url);
		},
	},
	getContractAnnual: {
		url: `${config.MAIN_URL}/market/contract/getContractAnnual`,
		name: "合同年度下拉",
		get: async function () {
			return await http.get(this.url);
		},
	},

	/* getFileInfo: {
		url: `${config.MAIN_URL}/market/demand/getFileInfo`,
		name: "文件上传数据回显-需求",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	}, */

	companyIdCascadeContractNo: {
		url: `${config.MAIN_URL}/market/demand/companyIdCascadeContractNo`,
		name: "需求管理-公司合同名称级联下拉",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},

	addDemand: {
		url: `${config.MAIN_URL}/market/demand/addDemand`,
		name: '新增需求',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	updateDemand: {
		url: `${config.MAIN_URL}/market/demand/updateDemand`,
		name: "编辑需求",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	},
	deleteDemand: {
		url: `${config.MAIN_URL}/market/demand/deleteDemand`,
		name: "删除需求",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},

};
